import { RECORDS_CHANGED } from "./recordChanges";
export const SCHEDULE_EVENT = "rpo:open-interview-scheduler";
export const INTERVIEWS_CHANGED = "rpo:interviews-changed";
export const openInterviewScheduler = (context = {}) => window.dispatchEvent(new CustomEvent(SCHEDULE_EVENT, { detail: context }));
const API_BASE = (process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");
export async function schedulingRequest(path, options = {}) {
  const token = ["token", "authToken", "jwt", "accessToken"].map(key => localStorage.getItem(key)).find(Boolean);
  const response = await fetch(`${API_BASE}/api${path}`, { credentials: "include", ...options,
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}), ...options.headers } });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.error || "Unable to update the interview.");
  return payload;
}
const interviewLoads = new Map();
export function loadInterviews(context = {}) {
  const query = new URLSearchParams();
  for (const key of ["candidateId", "jobId", "contactId", "scope", "from", "to", "includeDiscovery"]) if (context[key]) query.set(key, String(context[key]));
  const token = ["token", "authToken", "jwt", "accessToken"].map(key => localStorage.getItem(key)).find(Boolean) || "";
  const key = `${token}:${query}`;
  const cached = interviewLoads.get(key);
  if (cached && Date.now() - cached.time < 15000) return cached.promise;
  const promise = schedulingRequest(`/calendar/interviews?${query}`).catch(error => { interviewLoads.delete(key); throw error; });
  interviewLoads.set(key, { time: Date.now(), promise });
  return promise;
}
export function interviewsChanged() {
  interviewLoads.clear();
  window.dispatchEvent(new Event(INTERVIEWS_CHANGED));
  window.dispatchEvent(new Event("rpo:activities-refresh"));
  try { localStorage.setItem("rpo:interviews-updated", `${Date.now()}:${Math.random()}`); } catch {}
}

window.addEventListener("storage", event => {
  if (event.key !== "rpo:interviews-updated") return;
  interviewLoads.clear();
  window.dispatchEvent(new Event(INTERVIEWS_CHANGED));
  window.dispatchEvent(new Event("rpo:activities-refresh"));
});

window.addEventListener(RECORDS_CHANGED, () => {
  interviewLoads.clear();
  window.dispatchEvent(new Event(INTERVIEWS_CHANGED));
});
